<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">{{ eventInfo.name }}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('sessions.index', [eventInfo.id])">Sessions</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ session.name }}
    </h1>
    <trashed-message v-if="session.deleted_at" class="mb-6" @restore="restore">
      This session has been deleted.
    </trashed-message>
    <div class="flex flex-wrap">
      <div class="w-full lg:w-1/2 px-2">
        <div class="bg-white rounded-md shadow overflow-hidden mb-8">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <div class="pr-6 pb-8 w-full"><span class="font-semibold block">Type:</span>{{ session.type }}</div>
              <div class="pr-6 pb-8 w-full"><span class="font-semibold block">Location:</span>{{ session.location }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Start Time:</span>{{ dateFormatFixed(session.start_time) }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">End Time:</span>{{ dateFormatFixed(session.end_time) }}</div>
            </div>
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
              <button v-if="!session.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Session</button>
              <inertia-link class="btn-indigo ml-auto" :href="route('sessions.edit', session.id)">Edit Session</inertia-link>
            </div>
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { DateTime } from "luxon";

export default {
  metaInfo() {
    return { title: this.session.name }
  },
  components: {
    SelectInput,
    TextInput,
    TrashedMessage,
    LoadingButton,
    Icon,
  },
  props: {
    session: Object,
    eventInfo: Object,
  },
  layout: Layout,
  data() {
    return {
    }
  },
  methods: {
    destroy() {
      if (confirm('Are you sure you want to delete this session?')) {
        this.$inertia.delete(this.route('sessions.destroy', this.session.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this session?')) {
        this.$inertia.put(this.route('sessions.restore', this.session.id))
      }
    },
    dateFormatFixed(iso) {
      if (iso) {
        return DateTime.fromISO(iso).setZone('utc').toFormat('dd LLL yyyy HH:mm')
      }

      return '';
    },
  },
}
</script>
